import { Dispatch } from "redux";
import { Blog } from "../types/blogTypes";
import {
  collection,
  doc,
  DocumentSnapshot,
  endAt,
  endBefore,
  getDoc,
  getDocs,
  getFirestore,
  limit,
  limitToLast,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

export const FETCH_BLOGS_REQUEST = "FETCH_BLOGS_REQUEST";
export const FETCH_BLOGS_SUCCESS = "FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_FAILURE = "FETCH_BLOGS_FAILURE";

export const fetchBlogsRequest = () => ({
  type: FETCH_BLOGS_REQUEST,
});

export const fetchBlogsSuccess = (blogsData: {
  blogs: Blog[];
  totalRecords: number;
}) => ({
  type: FETCH_BLOGS_SUCCESS,
  payload: blogsData,
});

export const fetchBlogsFailure = (error: string) => ({
  type: FETCH_BLOGS_FAILURE,
  payload: error,
});

// Define other item-related actions here...
export const createItem = () => async (dispatch: Dispatch) => {
  const newItem = `Item ${Date.now()}`;
  //dispatch({ type: CREATE_ITEM, payload: newItem });
};

export const fetchBlogs =
  (
    collectionS: string, // Name of the collection
    orderByProp: string, // Property to order by
    direction: "next" | "prev" | undefined,
    startAfterDoc?: DocumentSnapshot,
    endBeforeDoc?: DocumentSnapshot,
    numPerPage: number = 6
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(fetchBlogsRequest());
    const blogsData: {
      blogs: Blog[];
      totalRecords: number;
      lastDoc?: DocumentSnapshot;
      firstDoc?: DocumentSnapshot;
    } = {
      blogs: [],
      totalRecords: 0,
      lastDoc: undefined,
      firstDoc: undefined,
    };
    const blogs: Blog[] = [];

    const totalCountQuery = query(collection(db, "blogs"));
    const totalCountSnapshot = await getDocs(totalCountQuery);
    const total = totalCountSnapshot.size;

    const dataCollection = collection(db, collectionS);

    // Define the initial data query with ordering and limit
    let dataQuery = query(
      dataCollection,
      orderBy(orderByProp, "desc"),
      limit(numPerPage)
    );

    // Update query based on direction and provided documents
    if (direction === "next" && startAfterDoc) {
      // For next direction, start after the provided document
      dataQuery = query(dataQuery, startAfter(startAfterDoc));
    } else if (direction === "prev" && endBeforeDoc) {
      // For previous direction, end before the provided document and limit to last
      dataQuery = query(
        dataCollection,
        orderBy(orderByProp, "desc"),
        endBefore(endBeforeDoc),
        limitToLast(numPerPage)
      );
    }

    // Get snapshot of documents based on the final query
    const productsSnapshot = await getDocs(dataQuery);

    // Extract data from each document and map to an array of objects
    const products = productsSnapshot.docs.map((doc) => doc.data());

    blogsData.blogs = products as Blog[];
    blogsData.totalRecords = total;
    blogsData.lastDoc = productsSnapshot.docs[productsSnapshot.docs.length - 1];
    blogsData.firstDoc = productsSnapshot.docs[0];

    dispatch(fetchBlogsSuccess(blogsData));
  };

export const fetchBlogById =
  (blogUrl: string) => async (dispatch: Dispatch) => {
    dispatch(fetchBlogsRequest());

    try {
      const blogsData: {
        blogs: Blog[];
        totalRecords: number;
        latestBlogURL: string;
        previousBlogURL: string;
      } = {
        blogs: [],
        totalRecords: 0,
        latestBlogURL: "",
        previousBlogURL: "",
      };

      /* Query the "blogs" collection for a document with the specified blogUrl. */
      let q = query(
        collection(db, "blogs"),
        where("blogUrl", "==", `/blog/${blogUrl}`)
      );

      let docData: Blog | undefined;
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        docData = doc.data() as Blog;
      });

      /* Query the "blogs" collection for a document to get latest blog. */
      const latestBlogQuery = query(
        collection(db, "blogs"),
        orderBy("createdTime", "desc"),
        limit(1)
      );
      const latestBlogQuerySnapshot = await getDocs(latestBlogQuery);
      let latestBlogDocData: Blog | undefined;
      latestBlogQuerySnapshot.forEach((doc) => {
        latestBlogDocData = doc.data() as Blog;
      });

      if (docData && latestBlogDocData) {
        /* Query the "blogs" collection for a document with a createdTime less than the current document's createdTime. */
        const previousBlogQuery = query(
          collection(db, "blogs"),
          where("createdTime", "<", docData.createdTime),
          orderBy("createdTime", "desc"),
          limit(1)
        );
        const previousBlogQuerySnapshot = await getDocs(previousBlogQuery);
        let previousBlogDocData: Blog | undefined;
        previousBlogQuerySnapshot.forEach((doc) => {
          previousBlogDocData = doc.data() as Blog;
        });

        blogsData.blogs = [docData] as Blog[];
        blogsData.totalRecords = 1;
        blogsData.latestBlogURL = latestBlogDocData.blogUrl;
        if (previousBlogDocData) {
          blogsData.previousBlogURL = previousBlogDocData.blogUrl;
        }
      }

      dispatch(fetchBlogsSuccess(blogsData));
    } catch (error) {
      console.error(error);
      dispatch(fetchBlogsFailure("Error fetching items."));
    }
  };
